import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
} from "@chakra-ui/react";
import React from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PaymentConditionModal = ({
  isOpen,
  onClose,
  onConfirm,
}: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Attention</ModalHeader>

        <ModalBody>
          <Text>
            අප ආයතනයටත් ඔබටත් කිසිදු නීතීමය ගැටලුවක් ඇති නොවීම සදහා ඔබ කරන
            ගෙවීමේ නිත්‍යානුකූල බව තහවුරු කිරීම සදහා , ගෙවීම සිදු කරන පුද්ගලයාගේ
            අදාල නියමිත විස්තර නිවැරදිව ලබාදෙන්න කාරුණික වන්න!
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Close
          </Button>

          <Button
            colorScheme="blue"
            onClick={() => {
              onClose()
              onConfirm()
            }}
          >
            ඉදිරියට යන්න
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
};

export default PaymentConditionModal;
